<template>
  <v-row>
    <!-- <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours"
    >
      <label class="title-label"
        >Hours*
        <tip-icon>
          Enter the number of hours the volunteer is expected to work.<br />
          This number is used by your volunteer check-in feature.
          <br />For multi-date needs, Enter the average number of hours expected
          each day.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours"
        label="Example: 4 or 3.5"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        type="number"
        :min="1"
        :error-messages="hoursMessage"
        @input="onChange"
      />
    </v-col> -->

    <!-- <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours_description"
    >
      <label class="title-label"
        >Hours Description*
        <tip-icon>
          Let the volunteer know when the need is scheduled to start and end.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours_description"
        label="Example: 9am - 5pm"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        :error-messages="hoursDescriptionMessage"
        dense
      />
    </v-col> -->
    <!-- <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="capacity"
    >
      <label class="title-label"
        >Capacity*
        <tip-icon>
          Enter the number of volunteer spots available.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.capacity"
        label="Example: 30"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        required
        dense
        type="number"
        autocomplete="off"
        @input="onCapacityInput"
        :error-messages="capacityMessage"
      />
    </v-col> -->
    <!-- Remove start date and end date fields for Is Ongoing -->
  </v-row>
</template>
<script>
export default {
  props: {
    need: Object,
    hoursMessage: String,
    capacityMessage: String,
    startDateErrorMessage: String,
    endDateErrorMessage: String,
    hoursDescriptionMessage: String,
    onChange: Function
  },
  data() {
    return {
      // ...existing code...
    };
  },
  computed: {
    // ...existing code...
  },
  methods: {
    onCapacityInput(value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue === "" || Number(numericValue) < 1) {
        this.need.capacity = 1;
      } else {
        this.need.capacity = Number(numericValue);
      }
    }
  },
  mounted() {
    // No start/end date for Is Ongoing
  }
};
</script>
<style scoped>
.title-label {
  width: 200px;
}
.warn-title {
  color: red;
  font-size: 12px;
  position: relative;
  bottom: 66px;
  padding: 0px 0px 0px 28%;
  top: -35px;
}
</style>
